import { z } from "zod";
import { ANSWERED_OUTCOMES, CALL_OUTCOMES, callViewSchema, phoneSlotSchema } from "./calls.js";
import { idSchema, multiLineTextSchema } from "./text.js";
// «Registra attività» (piano M5, Task 19, D15): la telefonata fatta fuori dal CRM, dal cellulare o da un altro telefono, inserita a
// mano dalla scheda del Lead con `POST /api/leads/:leadId/calls/manual`. Non passa dal fornitore della telefonia: non ha
// registrazione e non usa un numero del parco. Resta una chiamata in uscita valida, con l'esito in due passi come la postazione
// (M4, D7), i minuti di conversazione, gli appunti come nota della chiamata, l'autore vero e l'owner di allora; conta nella
// sequenza di chiamate al suo posto, completa il richiamo aperto fissato prima della sua ora e conta nei numeri del Lead.
/** Perché l'ora scelta non va (`422 manual_call_invalid` con `details.reason`): nel futuro, oppure prima che il Lead ci fosse. */
export const MANUAL_CALL_INVALID_REASONS = ["future", "before_lead"];
/** I minuti di conversazione al più (quattro ore). */
export const MANUAL_CALL_MAX_MINUTES = 240;
/**
 * La telefonata da registrare: quando è stata fatta (`at`, un istante: il giorno e l'ora scelti nel fuso dell'azienda), l'esito in
 * due passi (`answeredOutcome` soltanto dopo «Risposta», «Altro» vuole gli appunti: la regola è `validateOutcome` del dominio), i
 * minuti di conversazione (soltanto con una risposta; senza, zero), gli appunti, il telefono chiamato (`null`: il cellulare del
 * titolare, se c'è) e la chiave del browser: lo stesso `requestId` risponde la stessa chiamata.
 */
export const manualCallBodySchema = z.strictObject({
    at: z.iso.datetime(),
    outcome: z.enum(CALL_OUTCOMES),
    answeredOutcome: z.enum(ANSWERED_OUTCOMES).nullable(),
    minutes: z.number().int().min(0).max(MANUAL_CALL_MAX_MINUTES),
    note: multiLineTextSchema(4000).nullable(),
    phone: phoneSlotSchema.nullable(),
    requestId: idSchema,
});
/** La telefonata registrata (201), oppure quella già registrata con la stessa chiave (200). */
export const manualCallResponseSchema = z.object({ call: callViewSchema });
/** I dettagli di `422 manual_call_invalid`: il motivo. */
export const manualCallInvalidDetailsSchema = z.object({ reason: z.enum(MANUAL_CALL_INVALID_REASONS) });
//# sourceMappingURL=manual-calls.js.map